
// import 'vue-material/dist/vue-material.css';

import * as _ from 'lodash';
import 'es6-promise';

import axios, { AxiosResponse } from 'axios';
import Vue, { ComponentOptions } from 'vue';
import Component from 'vue-class-component';
import { Emit, Inject, Model, Prop, Provide, Watch } from 'vue-property-decorator'
// import VueMaterial from 'vue-material';

import ENAFileSelect from "./ENAFileSelect";

@Component({
  components: { 'ena-file-select': ENAFileSelect },
  props: {}
})
export default class ENAFlow extends Vue {
  public stepsComplete = {
    dataSource: true,
    sampleCart: true,
    pipelineParams: true,
  };

  onExitStep(stepName: string) {
    if (stepName === 'dataSource') {
      //
    }
    else if (stepName === 'sampleCart') {
      (this.$refs[stepName] as any).save();
    }
    else if (stepName === 'pipelineParams') {
      (this.$refs[stepName] as any).save();
    }
  }

  async startJob() {
    try {
      await (this.$refs['pipelineParams'] as any).run();
      this.$router.push('jobs');
    }
    catch (error) {
      throw error;
    }
  }
}

